module.exports = __webpack_public_path__ + "static/media/rate-3.d7946e4f.svg";